// Include jQuery plugins
//require('jquery.sample');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles

(($) => {
    const wntrTheme = {
        body: $('body'),
        html: $('html'),
        document: $(document),

        /**
         * Initialise theme JS on page load
         */
        init: function() {
            // Do we have JS?
            $('html').removeClass('no-js');

            // Automatically call all methods that start with __, in the order they're defined
            for (const prop in wntrTheme) {
                if (prop.startsWith('__') && typeof wntrTheme[prop] === 'function') {
                    wntrTheme[prop].call();
                }
            }
        },

        /**
         * Toggle hamburger menu for mobile devices
         */
        __toggleMainMenu: () => {
            wntrTheme.body.find('.header__toggle-menu').on('click', (e) => {
                $(e.currentTarget).toggleClass('is-active');
                wntrTheme.body.find('.header__mobile-menu').toggleClass('is-active');
            });
        },

        __tabs: () => {

            $('body').on('mousedown', () => {
                if (!$('body').hasClass('outline-inactive')) {
                    $('body').addClass('outline-inactive');
                }
            });

            $("body").on('keyup', function(e) {
                const keyCode = e.keyCode || e.which;
                if (keyCode == 9 && $('body').hasClass('outline-inactive')) {
                    $('body').removeClass('outline-inactive');
                }
            });
        },

        __initNewsletterConsent: () => {
            $(".newsletter__form").find("input[type=checkbox]").on('click', (e) => {
                $(e.currentTarget).toggleClass('active');
            });
        },

        __initHeaderFunctions: () => {

            ['is-zoomed', 'is-ledgible', 'is-read', 'is-translate'].forEach((cookie) => {
                getCookie(cookie) === 'true' ? $('html').toggleClass(cookie) : '';
            });

            wntrTheme.body.find('.header__search-toggle').on('click', () => {
                wntrTheme.body.find('.header__searchbar-wrapper').toggleClass('is-active');
                wntrTheme.body.find('.header__actions').toggleClass('is-active');
                wntrTheme.body.find('.header__top-searchbar').toggleClass('is-active');
                wntrTheme.body.find('.header__top-searchbar-input').focus();
            });

            wntrTheme.body.find('.header__action--zoom').on('click', () => {
                if ($('html').toggleClass('is-zoomed').hasClass('is-zoomed')) {
                    setCookie('is-zoomed', true, 100);
                } else {
                    setCookie('is-zoomed', false, 100);
                }
            });

            wntrTheme.body.find('.header__action--zoom-out').on('click', () => {
                if ($('html').toggleClass('is-zoomed').hasClass('is-zoomed')) {
                    setCookie('is-zoomed', true, 100);
                } else {
                    setCookie('is-zoomed', false, 100);
                }
            });

            wntrTheme.body.find('.header__action--read').on('click', () => {
                if (wntrTheme.body.find('.ledgible').text().length > 0) {
                    if ($('html').toggleClass('is-ledgible').hasClass('is-ledgible')) {
                        setCookie('is-ledgible', true, 100);
                    } else {
                        setCookie('is-ledgible', false, 100);
                    }
                }
            });

            wntrTheme.body.find('.header__action--translate').on('click', () => {
                wntrTheme.body.find('.header__translate').toggleClass('is-active');
            });

            wntrTheme.body.find('.header__action--home').on('click', () => {
                setCookie('is-zoomed', false, 100);
                setCookie('is-ledgible', false, 100);
                document.location.href = "/";
            });

            function setCookie(cname, cvalue, exdays) {
                const d = new Date();
                d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
                const expires = "expires=" + d.toUTCString();
                document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
            }

            function getCookie(cname) {
                const name = cname + "=";
                const decodedCookie = decodeURIComponent(document.cookie);
                const ca = decodedCookie.split(';');
                for (let i = 0; i < ca.length; i++) {
                    let c = ca[i];
                    while (c.charAt(0) === ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return "";
            }
        },

        __initSmoothSectionScroll: function() {
            $('.side-menu-about').first().addClass('is-active');
            const anchor = $('.side-menu-about');
            if (anchor.length) {
                anchor.on('click', function(e) {
                    e.preventDefault();
                    updateActiveLink(e.currentTarget);
                    $('html, body').animate({ scrollTop: $(e.target.hash).offset().top }, 500);
                });
            }

            function updateActiveLink(target) {
                $('.side-menu-about').removeClass('is-active');
                $(target).addClass('is-active');
            }
        },

        /**
         * Initialize Slick slider calendar__bottom
         */
        __initSlick: function() {
            $('.employees').slick({
                arrows: false,
                dots: true,
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 719,
                        settings: "unslick"
                    }
                ]
            });
            $('.calendar__bottom').slick({
                infinite: false,
                arrows: true,
                dots: true,
                slidesToShow: 3,
                slidesToScroll: 3,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 720,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        },
    };

    $(document).ready(wntrTheme.init);
})(jQuery);